<template>
  <ModalContainer class="basic-modal" v-bind:modal-mask-clicked="modalMaskClicked">
    <Card class="modal-content mx-auto">
      <div class="mdl-card__title typography-color-black typography-font-weight-500 basic-modal-header" v-html="title">
      </div>

      <div class="mdl-card__supporting-text mdl-typography-body-1 basic-modal-body">
        <slot></slot>
      </div>

      <div class="mdl-card__actions text-right basic-modal-actions">
        <button class="mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect" v-show="btnCancelShow"
                v-on:click="$emit('cancel')"
                v-mdl>
          <span v-text="btnCancel"></span>
        </button>
        <button class="mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect" v-show="btnOKShow"
                v-on:click="$emit('ok')"
                v-mdl>
          <span v-text="btnOK"></span>
        </button>
      </div>
    </Card>
  </ModalContainer>
</template>

<script>
export default {
  name: 'basic-modal',

  props: {
    title: {
      type: String,
      default: 'Title',
    },
    btnCancel: {
      type: String,
      default: '취소',
    },
    btnOK: {
      type: String,
      default: '확인',
    },
    btnCancelShow: {
      type: Boolean,
      default: true,
    },
    btnOKShow: {
      type: Boolean,
      default: true,
    },
    modalMaskClicked: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style lang="scss">
  .basic-modal {
    .mdl-card {
      width: 285px;
      min-height: 156px;
      max-height: 90vh;
    }

    .basic-modal-header {
      padding: 24px 24px 6px;
      font-size: 16px;
      line-height: 23px;
    }

    .basic-modal-body {
      padding: 6px 24px;
      min-height: 51px;
      overflow-y: auto;
      width: 100%;
    }

    .basic-modal-actions {
      .mdl-button {
        font-size: 15px;
      }
    }
  }
</style>
